import React, { useState } from "react";
import styles from "../servicesProvided/servicesProvided.module.scss";
import cardIcon1 from "../../../assests/cardIcon1.png";
import cardIcon2 from "../../../assests/cardIcon2.png";
import cardIcon3 from "../../../assests/cardIcon3.png";

const servicesData = [
  {
    id: 1,
    iconImg: cardIcon1,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
  {
    id: 2,
    iconImg: cardIcon2,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
  {
    id: 3,
    iconImg: cardIcon3,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
  {
    id: 4,
    iconImg: cardIcon1,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
  {
    id: 5,
    iconImg: cardIcon2,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
  {
    id: 6,
    iconImg: cardIcon3,
    title: "Domain Registration Services",
    description:
      "Domain registration is the process of purchasing and reserving a unique website address.",
  },
];
const ServicesProvided = () => {
  const [activatedCards, setActivatedCards] = useState([1]);

  const activateCard = (id) => {
    if (!activatedCards.includes(id)) {
      setActivatedCards((prev) => [...prev, id]);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.servicesTop}>
          <div className={styles.heading}>Domain Service Provided</div>
          <div className={styles.description}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis.
          </div>
        </div>
        <div className={styles.servicesBottom}>
          {servicesData?.map((item) => (
            <div
              key={item?.id}
              className={`${styles.card} ${
                activatedCards.includes(item?.id) ? styles.active : ""
              }`}
              onMouseEnter={() => activateCard(item?.id)}
            >
              <div className={styles.cardIcon}>
                <img src={item?.iconImg} alt="" />
              </div>
              <div className={styles.content}>
                <div className={styles.title}>{item?.title}</div>
                <div className={styles.servicesDescription}>
                  {item?.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesProvided;
